export const IMAGES = {
    logos: {
        facebook: 'https://signature.shipsierra.com/images/logos/facebook.png',
        instagram: 'https://signature.shipsierra.com/images/logos/instagram.png',
        threads: 'https://signature.shipsierra.com/images/logos/threads.png',
        tiktok: 'https://signature.shipsierra.com/images/logos/tiktok.png',
        x: 'https://signature.shipsierra.com/images/logos/x.png',
        youtube: 'https://signature.shipsierra.com/images/logos/youtube.png',
    },
} as const